export default __webpack_public_path__ + "static/design_mobile_reversed-ab4a51d2f5df48edcddbe3d5fa711a36.mp4";